module.exports = __webpack_public_path__ + "img/weixin.b068ac07.jpg";